import React, { createContext, ReactNode, useContext, useState } from 'react';

import { Context } from './index.types';
import { FileDTO } from '@/components/ui/Inputs/types/response/file';

type KimPushPullProviderProps = {
	children: ReactNode;
};

const KimPushPullContext = createContext<Context>({} as Context);

export function KimPushPullProvider({ children }: KimPushPullProviderProps) {
	const [file, setFile] = useState<FileDTO>({} as FileDTO);

	function handleFile(file: FileDTO | undefined) {
		if (file) {
			setFile(file);
		}
	}

	const contextValue: Context = {
		file,
		handleFile,
	};

	return <KimPushPullContext.Provider value={contextValue}>{children}</KimPushPullContext.Provider>;
}

export function useKimPushPullContext() {
	const context = useContext(KimPushPullContext);
	return context;
}
